import * as R from 'ramda'
import { createSelector } from 'reselect'

import { currentUser } from './common'
import { properties, listings, leases, historyPrice, owners, applications, transactions, terms} from './entities'
import { transactionsEx } from './transactions'

import {equityProperty} from 'helpers/kpi/equity'
import daysForRent from 'helpers/kpi/daysForRent'
import occupancyRate from 'helpers/kpi/occupancyRate'
import incomeStatement from 'helpers/kpi/incomeStatement'
import newRoi from 'helpers/kpi/newRoi'
import roiWithGain from 'helpers/kpi/roiWithGain'
import taxDeferal from 'helpers/kpi/taxDeferal'
import depreciation from 'helpers/kpi/depreciation'
import breakdown from 'helpers/kpi/breakdown'
import investment from 'helpers/kpi/investment'

import { parsePeriod } from 'utils/stuff'
import moment from 'moment'

export let perfomancePeriod = state => state.finance.perfomancePeriod
export let taxBracket = createSelector([owners, currentUser], (owners, userID) => R.pipe(R.values, R.filter(x => x._id == userID), (owner) => owner[0] && owner[0].taxBracket || 50)(owners))
export let historyPriceByPropertyID = createSelector(historyPrice, R.pipe(R.values, R.groupBy(R.prop('propertyID'))))
export let startMarketDateByPropertyID = createSelector(
	[listings, applications, leases]
  , (listings, applications, leases) => {
 	return R.pipe(
 		R.values
	  , R.groupBy(R.prop('propertyID'))
	  , R.map(propertyDocs => R.sortBy(x => moment(x.date || x.dateFrom))(propertyDocs)[0].date || R.sortBy(x => moment(x.date || x.dateFrom))(propertyDocs)[0].dateFrom)
 	)(R.mergeAll([listings, applications, leases]))
 }
)
export let incomeStatementByPropertyID = createSelector(
	[transactionsEx, properties, leases, listings, startMarketDateByPropertyID, perfomancePeriod]
  , (transactions, properties, leases, listings, startMarketDateByPropertyID, perfomancePeriod) => {
	return incomeStatement(transactions, properties, leases, listings, startMarketDateByPropertyID, perfomancePeriod)
})
export let equityByPropertyID = createSelector([historyPrice, properties], (historyPrice, properties) => equityProperty(historyPrice, properties))
export let principalPaidByPropertyID = createSelector(
	[properties, perfomancePeriod]
  , (properties, perfomancePeriod) => {
		let period = perfomancePeriod == 'projected' ? parsePeriod(moment().year()) : parsePeriod(perfomancePeriod)
		let periodStartBreakDown = breakdown(properties, period.from)
		let periodEndBreakDown = breakdown(properties, period.to)
		let res = R.map(x => x.balance)(R.mergeDeepWith(R.subtract, periodStartBreakDown, periodEndBreakDown))
		return res
	}
)
export let depreciationByPropertyID = createSelector(
	[properties, startMarketDateByPropertyID, perfomancePeriod],
	(properties, startMarketDateByPropertyID, perfomancePeriod) =>{
		return depreciation(properties, startMarketDateByPropertyID, perfomancePeriod)
	}
)
export let taxDeferalByPropertyID = createSelector(
	[transactionsEx, properties, leases, listings, taxBracket, startMarketDateByPropertyID, perfomancePeriod],
	(transactions, properties, leases, listings, taxBraket, startMarketDateByPropertyID, perfomancePeriod) =>{
		return taxDeferal(transactions, properties, leases, listings, taxBraket, startMarketDateByPropertyID, perfomancePeriod)
	}
)
export let investmentByPropertyID = createSelector([properties], (properties) => investment(properties))
export let roiByPropertyID = createSelector(
	[properties, transactionsEx, leases, listings, taxBracket, startMarketDateByPropertyID, perfomancePeriod]
  , (properties, transactions, leases, listings, taxBracket, startMarketDateByPropertyID, perfomancePeriod) =>
	newRoi(properties, transactions, leases, listings, taxBracket, startMarketDateByPropertyID, perfomancePeriod)
)
export let roiWithGainByPropertyID = createSelector(
	[properties, transactionsEx, leases, listings, historyPrice, taxBracket, startMarketDateByPropertyID, perfomancePeriod]
  , (properties, transactions, leases, listings, history, taxBracket, startMarketDateByPropertyID, perfomancePeriod) =>
	roiWithGain(properties, transactions, leases, listings, history, taxBracket, startMarketDateByPropertyID, perfomancePeriod)
)
export let daysForRentByPropertyID = createSelector(
	[properties, listings, perfomancePeriod]
  , (properties, listings, perfomancePeriod) => daysForRent(properties, listings, perfomancePeriod)
)
export let occupancyRateByPropertyID = createSelector(
	[properties, leases, terms, startMarketDateByPropertyID, perfomancePeriod]
  , (properties, leases, terms, startMarketDateByPropertyID, perfomancePeriod) =>
	occupancyRate(properties, leases, terms, startMarketDateByPropertyID, perfomancePeriod)
)



// WEBPACK FOOTER //
// ./src/selectors/perfomance.js